import { createFileRoute, useParams } from "@tanstack/react-router";
import { useProject } from "@/hooks/use-project";
import { SettingsView } from "@/components/projects/settings-view/settings-view";

export const Route = createFileRoute("/projects/$projectId/settings/")({
  component: SettingsPage,
});

function SettingsPage() {
  const { projectId } = useParams({
    from: "/projects/$projectId/settings/",
  });
  const { data: project } = useProject(projectId);

  // The parent project layout already gates on load/error before rendering
  // this outlet, so the project is in cache by the time we get here.
  if (!project) return null;

  return <SettingsView project={project} />;
}
